<template>
  <RouterView />
  <AppNotification />
</template>

<script setup lang="ts">
import AppNotification from '@/components/AppNotification/AppNotification.vue';
</script>
